<template>
    <div>
        <Spin v-if="spinshow" fix></Spin>
        <Card style="width:600px">
            <Tree :data="tree" :render="renderTree"></Tree>
        </Card>
        <Modal v-model="modal1" :title='popTitle' width=500  :mask-closable='false'>
            <Form :label-width=150 label-position="right" ref="permission" :model="permission" :rules="ruleValidate">
                <FormItem label="菜单名称" prop="menuName">
                    <Input v-model="permission.menuName" style="width:200px"></Input>
                </FormItem>
                <FormItem label="显示名称" prop="displayName">
                    <Input v-model="permission.displayName" style="width:200px"></Input>
                </FormItem>
                <FormItem label="菜单链接" prop="url">
                    <Input v-model="permission.url" style="width:200px"></Input>
                </FormItem>
                <FormItem label="图标名称" prop="url">
                    <Input v-model="permission.icon" style="width:200px"></Input>
                </FormItem>
                <FormItem label="排序" prop="sort">
                    <Input v-model="permission.sort" style="width:200px"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="ok('permission')">确认</Button>
            </div>
        </Modal>
        <Modal v-model="modal2" width="360">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>确认删除</span>
            </p>
            <div style="text-align:center">
                <p>确认后，{{permission.displayName}}会被删除</p>
                <p>确认删除吗？</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long @click="del">删除</Button>
            </div>
        </Modal>
        <Modal v-model="modal3" title='一键添加'>
            <Tree :data="list" ref="perTree" show-checkbox @on-check-change="selected"></Tree>
            <div slot="footer">
                <Button type="primary" @click="ok_menu">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>

import ajax from '@/lib/ajax.ts'
import userAjax from '@/lib/userAjax'

export default {
    name:'permissionManage',
    data(){
        return{
            spinshow:false,
            tree:[],
            modal1:false,
            modal2:false,
            modal3:false,
            list: [
                {title: '角色',
                expand: true,
                children: [],
                id: ''
                }],
            ruleValidate:{
                menuName:[{required:true,message:'请输入菜单名称',trigger:'blur'}],
                displayName:[{required:true,message:'请输入显示名称',trigger:'blur'}],
                url:[{required:false,message:'请输入显示名称',trigger:'blur'}],
                sort:[{required:false,message:'请输入显示名称',trigger:'blur'}]
            },
            permission:{
                id:null,
                parentId: null,
                menuName: "",
                displayName: "",
                permissionName: "",
                url:"",
                sort: 0,
            },
            popTitle: '添加菜单'  ,
            selection: []          
        }
    },
    methods:{
        async getPermission(){
            this.spinshow=true;
            let rep =await ajax.get("/api/services/app/AbpMenu/GetAllListByTenant");
            if(rep.data.success){
                this.tree=this.getJsonTree(rep.data.result.items,null);
                this.spinshow=false;
            }
        },
        getJsonTree(data, parentId){
            let itemArr = [];
            for (let i = 0; i < data.length; i++) {
                let node = data[i];
                if (node.parentId === parentId) {
                    let newNode = {};
                    newNode.id = node.id;
                    newNode.name = node.displayName;
                    newNode.parentId = node.parentId;
                    newNode.menuName = node.name;
                    newNode.permissionName = node.permissionName,
                    newNode.icon = node.icon;
                    newNode.sort = node.sort;
                    newNode.url = node.url;
                    newNode.expand = true;
                    //newNode.filePath = node.filePath;
                    newNode.children = this.getJsonTree(data, node.id);
                    itemArr.push(newNode);
                }
            }
            return itemArr;
        },
        renderTree(h,{root,node,data}){
            return h('span', {
                    'class': {
                        'permission-item': true
                    },
                }, [
                    h('span', data.name),
                    h('span', {
                        style: {
                            display: 'inline-block',
                            float: 'right',
                            marginRight: '32px'
                        }
                    }, [
                        h('Button', {
                            props: {
                                type:'primary',
                                size:'small'
                            },
                            style: {
                                marginRight: '8px'
                            },
                            on: {
                                click: () => {
                                    this.permission={
                                        id:null,
                                        parentId: data.id,
                                        menuName: "",
                                        displayName: null,
                                        permissionName: "",
                                        icon: null,
                                        sort: '0',
                                        url: null,
                                        //filePath: ""
                                    };
                                    this.popTitle = '添加菜单'
                                    this.modal1=true;
                                }
                            }
                        },'新增'),
                        h('Button', {
                            props: {
                                type:'warning',
                                size:'small'
                            },
                            style: {
                                marginRight: '8px'
                            },
                            on: {
                                click: () => {
                                    this.permission={
                                        id:data.id,
                                        parentId: data.parentId,
                                        menuName: data.menuName,
                                        displayName: data.name,
                                        permissionName: data.permissionName,
                                        icon: data.icon,
                                        // sort: data.sort,
                                        sort: `${data.sort}`,
                                        url: data.url,
                                        //filePath: data.filePath
                                    };
                                    this.permission.sort = data.sort + '' // 转字符串类型，iview识别
                                    this.popTitle = '编辑菜单'
                                    this.modal1=true;
                                }
                            }
                        },'编辑'),
                        h('Button', {
                            props: {
                                type:'error',
                                size:'small'
                            },
                            style: {
                                marginRight: '8px'
                            },
                            on: {
                                click: () => {
                                    this.permission={
                                        id:data.id,
                                        parentId: data.parentId,
                                        menuName: data.menuName,
                                        displayName: data.name,
                                        permissionName: data.permissionName,
                                        icon: data.icon,
                                        sort: data.sort,
                                        url: data.url,
                                        //filePath: data.filePath
                                    };
                                    this.modal2=true;
                                }
                            }
                        },'删除'),
                        h('Button', {
                            props: {
                                type:'success',
                                size:'small'
                            },
                            // 'class': {
                            //     'dis_add': node.children.length!=0
                            // },
                            on: {
                                click: () => {
                                    this.selection = []
                                    this.modal3 = true
                                    this.list.id = data.id
                                    // 重置checkbox
                                    this.list[0].children.forEach(role => {
                                        this.$set(role,'checked',false)
                                    })
                                    ajax.get('/api/services/app/AbpMenu/GetRoleListByMenuId?menu_id=' + this.list.id).then(res => {
                                        res.data.result.items.forEach(el => {
                                            this.selection.push(el.id)
                                            this.list[0].children.forEach(role => {
                                                if (el.id === role.id) {
                                                    this.$set(role,'checked',true)
                                                }
                                            })
                                        })
                                    })
                                }
                            }
                        },'一键添加'),
                    ])
                ]);
        },
        async ok(name){
            this.$refs[name].validate(async(valid)=>{
                if(valid){
                    let data={
                        "abpMenu": {
                            "id": this.permission.id,
                            "parentId": this.permission.parentId,
                            "name": this.permission.menuName,
                            "displayName": this.permission.displayName,
                            "permissionName": this.permission.permissionName,
                            "icon": this.permission.icon,
                            "sort": this.permission.sort,
                            "url": this.permission.url,
                            //"filePath": this.permission.filePath
                        }
                    }
                    let rep = await ajax.post("/api/services/app/AbpMenu/CreateOrUpdate",data);
                    if(rep.data.success){
                        this.modal1=false;
                        this.getPermission();
                    }
                }
                else{
                    this.$Message.error('请完善资料')
                }
            })
        },
        async del(){
            let rep = await ajax.delete("/api/services/app/AbpMenu/Delete",{
            params:{
                id:this.permission.id
            }
            });
            if(rep.data.success){
                this.modal2=false;
                this.getPermission();
            }
        },
        async ok_menu(){
            //一键添加
            let role_arr = this.$refs.perTree.getCheckedNodes().filter(item=>{
                return !item.children
            }).map(item=>{
                return item.id
            })
            let req = await ajax.put('/api/services/app/AbpMenu/UpdateMenuByRoles?menu_id='+this.list.id,role_arr)
            if(req.data.success){
                this.$Message.success("修改成功");
                this.modal3=false;
            }
        },
        selected(val) {
            this.selection = []
            val.forEach(el => {
                this.selection.push(el.id)
            })
        }
    }, 
    async created(){
        this.getPermission();
        let reponse=await userAjax.get('/api/services/app/Role/GetAll?skipCount=0&&maxResultCount=100');
        reponse = reponse.data.result.items.map(item=>{
            return {title: item.displayName,
                    id: item.id
            }
        })
        this.list[0].children = reponse
    }
}
</script>

<style lang="less">
    .permission-item {
        display: inline-block;
        width: 92%;
        padding: 3px 5px;
        cursor: pointer;
        &:hover {
            background: rgba(45, 140, 240, 0.2);
            border-radius: 5px;
        }
    }  
    .ivu-modal-body {
      max-height: 300px;
      overflow-y: auto;
      &::-webkit-scrollbar {display:none}
    }
    // .dis_add {
    //     background-color: #fff!important;
    //     border: 1px solid #fff;
    // } 
    // .dis_add:hover{
    //     border: 1px solid #fff!important;
    //     background-color: rgba(45, 140, 240, 0.2)!important;
    //     color: rgba(45, 140, 240, 0.2)!important;
    //     border: 1px solid rgba(45, 140, 240, 0.2)!important;
    // }
</style>